import { useState, useCallback } from "react";

export const useUserModal = ({ prefillForm, resetForm }) => {
  const [modalMode, setModalMode] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const modalOpen = modalMode !== null;

  const closeModal = useCallback(() => {
    if (typeof resetForm === "function") {
      resetForm();
    }
    setModalMode(null);
    setSelectedUser(null);
  }, [resetForm]);

  const openCreateModal = useCallback(() => {
    if (typeof resetForm === "function") {
      resetForm();
    }
    setSelectedUser(null);
    setModalMode("create");
  }, [resetForm]);

  const openEditModal = useCallback(
    (user) => {
      if (typeof prefillForm === "function") {
        prefillForm(user);
      }
      setSelectedUser(user);
      setModalMode("edit");
    },
    [prefillForm],
  );

  return {
    modalMode,
    modalOpen,
    selectedUser,
    openCreateModal,
    openEditModal,
    closeModal,
  };
};

export default useUserModal;
